var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8641 8.60333C17.6745 8.60333 18.3315 7.94635 18.3315 7.13593C18.3315 6.3255 17.6745 5.66852 16.8641 5.66852C16.0536 5.66852 15.3967 6.3255 15.3967 7.13593C15.3967 7.94635 16.0536 8.60333 16.8641 8.60333Z",
    fill: "#798797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3342 2C12.8387 2 11.4077 2.60863 10.3704 3.68582L4.12861 10.1677C2.60329 11.7517 2.62701 14.2653 4.18193 15.8202L8.43435 20.0726C9.84792 21.4862 12.133 21.5077 13.573 20.1211L20.539 13.4132C21.4725 12.5142 22 11.2739 22 9.9779V6.76907C22 4.13519 19.8648 2 17.2309 2H14.3342ZM11.9559 5.21261C12.5783 4.56629 13.4369 4.20111 14.3342 4.20111H17.2309C18.6492 4.20111 19.7989 5.35083 19.7989 6.76907V9.9779C19.7989 10.6758 19.5149 11.3436 19.0122 11.8277L12.0462 18.5356C11.4702 19.0903 10.5562 19.0816 9.99077 18.5162L5.73836 14.2638C5.03157 13.557 5.02079 12.4144 5.71412 11.6945L11.9559 5.21261Z",
    fill: "#798797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.0796be9acbc19a991b218711e958e7cd.svg";
export { ForwardRef as ReactComponent };